import { FilledButton, OutlinedButton } from '../util/button';

interface RequestConfirmButtonFieldProps {
  onCorrect: () => void;
  onRequest: () => void;
  isEstimating: boolean;
}
export const RequestConfirmButtonField = ({
  onCorrect: onCancel,
  onRequest,
  isEstimating,
}: RequestConfirmButtonFieldProps) => {
  const handleClickCorrectRequest = () => onCancel();
  const handleClickRepairRequest = () => onRequest();
  return (
    <div className={'repair-service-request-button'}>
      <OutlinedButton
        onClick={handleClickCorrectRequest}
        label={'キャンセル'}
      />
      <FilledButton
        onClick={handleClickRepairRequest}
        label={'修理を依頼する'}
        disabled={isEstimating}
      />
    </div>
  );
};
